var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("定制明细")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("定制明细"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "定制" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择定制" },
                                    model: {
                                      value: _vm.ruleForm.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "name", $$v)
                                      },
                                      expression: "ruleForm.name",
                                    },
                                  },
                                  _vm._l(_vm.tableData, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.title,
                                        value: item.lvKey,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                staticStyle: { "margin-bottom": "16px" },
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.add()
                  },
                },
              },
              [_vm._v("添加")]
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData1 },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "propDesc",
                    label: "定制图标",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("img", {
                            staticStyle: { width: "50px", height: "50px" },
                            attrs: { src: scope.row.propDesc.icon, alt: "" },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "propDesc",
                    label: "定制名称",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.propDesc.title)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "propDesc", label: "定制值", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.propValue))]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "介绍", align: "center", prop: "propValue" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.propDesc.subTitle)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "排序", align: "center", prop: "sort" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "是否显示", align: "center", prop: "sort" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.display == 1
                            ? _c("span", { staticClass: "greenColor" }, [
                                _vm._v("是"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.display == 0
                            ? _c("span", { staticClass: "redColor" }, [
                                _vm._v("否"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                编辑\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn redColor1",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteItem(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                删除\n              ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticStyle: { margin: "0 auto" },
              attrs: {
                "label-position": "right",
                model: _vm.ruleForm1,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "定制图标", prop: "icon" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        action: _vm.uploadUrl,
                        headers: _vm.deader,
                        "show-file-list": false,
                        "on-success": _vm.handleAvatarSuccess,
                      },
                    },
                    [
                      _vm.ruleForm1.icon
                        ? _c("img", {
                            staticClass: "avatar",
                            staticStyle: { width: "100px" },
                            attrs: { src: _vm.ruleForm1.icon },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ruleForm1.icon
                        ? _c("div", { staticClass: "modelView1" }, [
                            _vm._v("编辑"),
                          ])
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "定制名称", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入定制名称" },
                    model: {
                      value: _vm.ruleForm1.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "title", $$v)
                      },
                      expression: "ruleForm1.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "定制值", prop: "num" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入定制值" },
                    model: {
                      value: _vm.ruleForm1.num,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "num", $$v)
                      },
                      expression: "ruleForm1.num",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "定制介绍", prop: "subTitle" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入定制介绍" },
                    model: {
                      value: _vm.ruleForm1.subTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "subTitle", $$v)
                      },
                      expression: "ruleForm1.subTitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入排序" },
                    model: {
                      value: _vm.ruleForm1.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "sort", $$v)
                      },
                      expression: "ruleForm1.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { label: "是否显示", prop: "sort" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm1.display,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm1, "display", $$v)
                        },
                        expression: "ruleForm1.display",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm1("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }